import { CircularProgress, Dialog, Divider, Grid, makeStyles } from "@material-ui/core";
import * as React from "react";
import { Button, Datagrid, List, TextField, TextInput, Toolbar, required, useNotify, useRefresh } from "react-admin";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import CreatedByField from "../../../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { SectionTitle } from "../../../../../../src/Components/SectionTitle";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../../../../src/Constants/Constant";
import { PbhRequestStatus } from "../../../../../../src/Enums/PbhRequestStatus";
import { Actions } from "./Actions";
import UpdatedByField from "../../../../../../src/Components/ReferenceFields/UpdatedBy/UpdatedByField";
import { Form } from "react-final-form";
import { Add } from "@material-ui/icons";
import { useAppDataProvider } from "../../../../../../src/dataprovider";
const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  gridItem: {
    margin: "0px 10px",
  },
}));
export default function PbhRequestOrderReserveForm(props) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();
  const dataProvider = useAppDataProvider();
  const classes = useStyles(props);
  const refresh = useRefresh();
  React.useEffect(() => {
    setOpen(props?.open ?? false);
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
    props?.handleClose(false);
  };
  const handleSubmit = values => {
    setLoading(true);
    dataProvider
      .postPbhReserve(values)
      .then(result => {
        notify(`Record created`, "success", false, true);
        refresh?.();
        props?.callback?.();
      })
      .catch(result => {
        notify(`${result?.response?.data ?? result}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div>
      <Dialog open={open} onClose={handleClose} maxWidth={"lg"}>
        <Grid container style={{ padding: 20 }}>
          {props.tabValue == PbhRequestStatus.UnshippedSvc && (
            <Grid item xs={12}>
              <Form
                onSubmit={handleSubmit}
                render={({ handleSubmit, form, values }) => {
                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid style={{ width: "100%" }} container spacing={2}>
                        <Grid
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                          item
                          xs={12}
                        >
                          <Divider />
                          <Divider />
                          <SectionTitle variant={"h5"} label={"Create Form"} />
                        </Grid>

                        <Grid item xs={6} sm={3} lg={3}>
                          <TextInput
                            source="requestId"
                            label="Request"
                            fullWidth
                            disabled
                            defaultValue={props.requestId}
                            validate={required()}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={3}>
                          <TextInput
                            source="refNo"
                            label="Request Ref No"
                            fullWidth
                            disabled
                            defaultValue={props.refNo}
                            validate={required()}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={3}>
                          <TextInput source="pn" label="Pn" fullWidth validate={required()} variant="outlined" />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={3}>
                          <TextInput source="sn" label="Sn" fullWidth validate={required()} variant="outlined" />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={3}>
                          <TextInput source="batch" label="Batch" fullWidth variant="outlined" />
                        </Grid>
                      </Grid>
                      <Toolbar {...props} placeholder="" className={classes.toolbar}>
                        <Button
                          label={loading ? "Creating!" : "Create"}
                          disabled={loading}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                        </Button>
                      </Toolbar>
                    </form>
                  );
                }}
              />
            </Grid>
          )}

          <Grid style={{ display: "flex", justifyContent: "center", marginTop: 30 }} item xs={12}>
            <Divider />
            <Divider />
            <SectionTitle variant={"h5"} label={"Reserved History (Ref No =" + props?.refNo + ")"} />
          </Grid>
          <Grid item xs={12}>
            <List
              {...props}
              title={" "}
              resource={"pbhrequestreserves"}
              basePath={"list"}
              filterDefaultValues={{ requestId__eq: props.requestId }}
              sort={DefaultCreatedDateSort}
              perPage={DefaultPerPageSize}
              actions={false}
              bulkActionButtons={false}
              exporter={false}
              hasCreate={false}
            >
              <Datagrid
                title={""}
                optimized
                rowStyle={(record, index) => ({
                  backgroundColor: record.isPassive === true ? "#3f3e3e2e" : "white",
                })}
              >
                <Actions label="Actions" />
                <TextField source="pn" label="Pn" />
                <TextField source="sn" label="Sn" />
                <TextField source="batch" label="Batch" />
                <CreatedByField label="Reserved By" link={false} />
                <CustomDateField source="createdDate" label="Reserved Date" showTime />
                <UpdatedByField label="Passivated By" link={false} />
                <CustomDateField source="updatedDate" label="Passivated Date" showTime />
              </Datagrid>
            </List>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
